const SESSION_STORAGE_KEY = "iot-debugger.page-session-id";

const makeSessionID = (): string => {
  const seed = `${Date.now()}-${Math.random()}-${Math.random()}`;
  return `ui_${btoa(seed).replace(/[+/=]/g, "").slice(0, 24)}`;
};

export const getPageSessionID = (): string => {
  if (typeof window === "undefined") {
    return "ui_server";
  }
  const existing = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (existing) {
    return existing;
  }
  const created = makeSessionID();
  window.sessionStorage.setItem(SESSION_STORAGE_KEY, created);
  return created;
};

